var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-info",attrs:{"role":"alert","aria-live":"polite"}},[_c('span',{staticClass:"fas fa-2x fa-info-circle c-alert__icon"}),_c('div',{staticClass:"c-alert__content",domProps:{"innerHTML":_vm._s(_vm.message)}})])}
var staticRenderFns = []

export { render, staticRenderFns }